<template>
  <v-card>
    <v-card-title>
      Položky ({{ count }})

      <v-spacer/>

      <Create
          :icon="true"
          @init="init"
      />

      &nbsp;

      <v-btn
          :icon="true"
          :outlined="true"
          :loading="loading"
          :disabled="loading"
          color="default"
          @click="init"
      >
        <v-icon>
          mdi-refresh
        </v-icon>
      </v-btn>

      &nbsp;

      <v-btn
          :icon="true"
          :outlined="true"
          color="default"
          @click="downloadFileByLink(loadLinkByPath('app/items/export'))"
      >
        <v-icon>
          mdi-download
        </v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-row>
        <v-col
            cols="12"
        >
          <v-text-field
              v-model="params.Filters.query"
              :error-messages="errors.Filters && errors.Filters.query"
              :outlined="true"
              :dense="true"
              hide-details="auto"
              label="Vyhľadávanie"
              :clearable="true"
              @change="setFilter"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col
            cols="12"
        >
          <v-expansion-panels
              v-model="expansionPanelsFilter"
              :multiple="true"
          >
            <v-expansion-panel>
              <v-expansion-panel-header>
                <span>
                  <v-icon
                      color="info"
                  >
                    mdi-filter
                  </v-icon>

                  Filtre
                </span>
              </v-expansion-panel-header>

              <v-expansion-panel-content/>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>

      <v-row>
        <v-col
            cols="12"
        >
          <v-card>
            <v-card-text>
              <v-progress-linear
                  v-if="loading"
                  :indeterminate="true"
              />

              <v-simple-table>
                <template
                    v-slot:default
                >
                  <thead>
                    <tr>
                      <th>
                        Fotografia
                      </th>

                      <th>
                        Výkres
                      </th>

                      <th
                          class="fixed"
                      >
                        <a
                            @click="setOrder($store.state.register.Item.Filter.order['it.orderNumber'].value)"
                        >
                          <v-icon
                              v-if="params.order === $store.state.register.Item.Filter.order['it.orderNumber'].value"
                          >
                            {{
                              params.by === $store.state.register.Item.Filter.by['ASC'].value
                                ? 'mdi-chevron-up'
                                : 'mdi-chevron-down'
                            }}
                          </v-icon>

                          Objednávkové číslo
                        </a>
                      </th>

                      <th>
                        Produktový typ
                      </th>

                      <th
                          class="text-right fixed"
                      />
                    </tr>
                  </thead>

                  <tbody>
                    <template
                        v-if="items.length > 0"
                    >
                      <tr
                          v-for="Item in items"
                          :key="Item.id"
                      >
                        <td>
                          <silent-box
                              v-if="Item.Photo"
                              :image="{
                                src: loadLinkByPath('files/generate/image/original/' + Item.Photo.token)
                              }"
                          >
                            <template
                                v-slot:silentbox-item
                            >
                              <v-img
                                  :src="loadLinkByPath('files/generate/image/thumbnail/36/36/' + Item.Photo.token)"
                                  alt="Fotografia"
                                  max-width="36px"
                              />
                            </template>
                          </silent-box>

                          <template
                              v-else
                          >
                            <v-icon
                                color="error"
                            >
                              mdi-close
                            </v-icon>
                          </template>
                        </td>

                        <td>
                          <silent-box
                              v-if="Item.Dimension"
                              :image="{
                                src: loadLinkByPath('files/generate/image/original/' + Item.Dimension.token)
                              }"
                          >
                            <template
                                v-slot:silentbox-item
                            >
                              <v-img
                                  :src="loadLinkByPath('files/generate/image/thumbnail/36/20/' + Item.Dimension.token)"
                                  alt="Výkres"
                                  max-width="36px"
                              />
                            </template>
                          </silent-box>

                          <template
                              v-else
                          >
                            <v-icon
                                color="error"
                            >
                              mdi-close
                            </v-icon>
                          </template>
                        </td>

                        <td
                            class="fixed"
                        >
                          {{ Item.orderNumber }}
                        </td>

                        <td>
                          <span
                              class="text-truncate"
                              style="max-width: 300px"
                          >
                            {{ Item.productType }}
                          </span>
                        </td>

                        <td
                            class="text-right fixed"
                        >
                          <v-btn
                              :icon="true"
                              :outlined="true"
                              color="primary"
                              :to="'/item/' + Item.id"
                          >
                            <v-icon>
                              mdi-magnify
                            </v-icon>
                          </v-btn>

                          &nbsp;

                          <Update
                              :icon="true"
                              :id="Item.id"
                              @init="init"
                          />

                          &nbsp;

                          <Delete
                              :icon="true"
                              :id="Item.id"
                              @init="init"
                          />
                        </td>
                      </tr>
                    </template>

                    <template
                        v-else
                    >
                      <tr>
                        <td
                            colspan="5"
                            class="text-center"
                        >
                          Nenašli sa žiadne položky.
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row
          v-if="pages !== 0"
          align="center"
      >
        <v-col
            cols="4"
        >
          <a
              v-for="(limit, i) in $store.getters['register/getItemFilterLimit']"
              :key="i"
              @click="setLimit(limit.value)"
          >
            {{ limit.text }}
          </a>
        </v-col>

        <v-spacer/>

        <v-col
            cols="auto"
        >
          <v-btn
              :icon="true"
              :outlined="true"
              :loading="loading"
              :disabled="params.page === 1 || loading"
              color="primary"
              @click="previousPage"
          >
            <v-icon>
              mdi-chevron-left
            </v-icon>
          </v-btn>
        </v-col>

        <v-col
            cols="auto"
        >
          {{ params.page }} / {{ pages }}
        </v-col>

        <v-col
            cols="auto"
        >
          <v-btn
              :icon="true"
              :outlined="true"
              :loading="loading"
              :disabled="params.page === pages || loading"
              color="primary"
              @click="nextPage"
          >
            <v-icon>
              mdi-chevron-right
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  import Qs from 'qs'
  import QueryTypes from 'query-types'

  import Items from '@/services/items'

  import Create from '@/components/Items/Create'
  import Update from '@/components/Items/Update'
  import Delete from '@/components/Items/Delete'

  export default {
    name: 'Items',
    components: {
      Create,
      Update,
      Delete
    },
    data() {
      return {
        expansionPanelsFilter: [],
        loading: false,
        count: 0,
        pages: 1,
        items: [],
        params: {
          Filters: {
            query: ''
          },
          order: this.$store.state.register.Item.Filter.order['it.orderNumber'].value,
          by: this.$store.state.register.Item.Filter.by['ASC'].value,
          limit: this.$store.state.register.Item.Filter.limit[25].value,
          page: 1
        },
        errors: {}
      }
    },
    metaInfo() {
      return {
        title: 'Položky'
      }
    },
    beforeMount() {
      this.beforeInit()
    },
    mounted() {
      this.init()
    },
    methods: {
      beforeInit() {
        this.params = {
          ...this.params,
          ...Qs.parse(QueryTypes.parseObject(this.$route.query))
        }
      },
      init() {
        this.loadData()
      },
      setFilter() {
        this.params.page = 1

        this.init()
      },
      setOrder(order) {
        this.params.order = order

        switch (this.params.by) {
          case this.$store.state.register.Item.Filter.by['ASC'].value:
            this.params.by = this.$store.state.register.Item.Filter.by['DESC'].value

            break

          case this.$store.state.register.Item.Filter.by['DESC'].value:
            this.params.by = this.$store.state.register.Item.Filter.by['ASC'].value

            break
        }

        this.params.page = 1

        this.init()
      },
      setLimit(limit) {
        this.params.limit = limit

        this.params.page = 1

        this.init()
      },
      previousPage() {
        this.params.page -= 1

        window.scrollTo(0, 0)

        this.init()
      },
      nextPage() {
        this.params.page += 1

        window.scrollTo(0, 0)

        this.init()
      },
      setBreadcrumbs() {
        this.$store.dispatch('layout/setBreadcrumbs', {
          breadcrumbs: [
            {
              text: 'Položky',
              to: '/items'
            }
          ]
        })
      },
      loadData() {
        this.setBreadcrumbs()

        this.loading = true

        this.$router.replace('?' + Qs.stringify(this.params))

        Items
          .index({
            params: this.params
          })
          .then((response) => {
            this.count = response.data.data.count

            this.pages = response.data.data.pages

            this.items = response.data.data.items

            this.errors = {}
          })
          .catch((error) => {
            switch (error.response.status) {
              case 400:
                this.errors = error.response.data.errors

                break

              case 401:
              case 500:
                this.$store.dispatch('layout/openSnackbar', {
                  message: error.response.data.message
                })

                break
            }
          })
          .finally(() => {
            this.loading = false
          })
      },
      loadLinkByPath(path) {
        return process.env.VUE_APP_AXIOS_URL + path
      },
      downloadFileByLink(link) {
        window.open(link)
      }
    }
  }
</script>
